angular.module('env.custom.customBackground', [])

    .directive('customBackground', function ($log, context, customResourceResolver) {
        return {
            restrict: 'A',
            controller: function ($scope, $element) {

                var oldValue = null;

                var recompile = function () {

                    var customAlias = $element.attr("custom-background");

                    if (!customAlias) {
                        $element.removeClass("background-image");
                        return;
                    }

                    customResourceResolver.resolveImage(customAlias, null).then(function (customImgUrl) {
                        if (customImgUrl == oldValue) {
                            return;
                        }
                        oldValue = customImgUrl;

                        if (angular.isDefined(customImgUrl) && angular.isString(customImgUrl)) {
                            $element.removeClass("background-image");
                            $element.addClass("custom-background");
                            $element.css("background-image", "url(" + customImgUrl + ")");
                        } else {
                            $log.warn("Can't find custom image for name '" + customAlias + "'");
                            $element.removeClass("background-image");
                        }
                    });
                };

                $scope.$watch(
                    function () {
                        return $element.attr("custom-background");
                    },
                    function (newVal, oldVal) {
                        if (newVal != oldVal) {
                            recompile();
                        }
                    }
                );

                //Subscribe to the context changed event to recompile directive and redraw the content if any
                //in order to reflect the template change according to the new context (user or any other customisation data)
                if (context) {
                    context.events.on('changed', function () {
                        recompile();
                    });
                }

                recompile();
            }
        };
    })

;